<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chapnumA" id="int"><a id="page_4"></a>Introduction</h2>
<p class="noindent">Creating your own buttons is a great way to add a unique feature to any hand-crafted project, from papercraft and journalling to making accessories and, of course, clothing. Making fabric buttons can be incredibly relaxing: using offcuts of fabric, each button can be a little work of art.</p>
<p class="indent">My love of button-making started during my studies of early passementerie techniques. The hand-crafted trimmings that embellish old garments are usually overlooked by costume historians, yet they are often the very aspect that finishes and unifies a garment. As I have got to grips with the techniques, I’ve been asked to create bespoke buttons for costumiers for a variety of uses, from modern one-off wedding gowns and designer coats to historical buttons for museums and films. I’m always learning too: as my collection of original antique and vintage passementerie buttons grows, so does my knowledge of the techniques.</p>
<p class="indent">Button-making really can be a bit of an addiction – I love it for so many reasons besides the historical aspect. It’s a social craft – you can work on fabric buttons while sitting with the family. My workshops are chatty, social events as in most cases everyone is still able to talk and work at the same time. You can take projects to work on while travelling or sitting in a waiting room. Making buttons is also a way to get those creative juices flowing. While I’m working on one design I’ll often have an idea for a variation, or another design altogether.</p>
<p class="indent">Ultimately, it is satisfying to wear a black coat with fantastic handcrafted buttons that replace the standard buttons supplied!</p>
<p><a id="page_5"></a></p>
<div class="image_container">
<img alt="images" src="images/img_005-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Introduction.vue?b8b75c7e